/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_CreatedInputs */

const en_settings_apikeys_created = /** @type {(inputs: Settings_Apikeys_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key created`)
};

const zh_settings_apikeys_created = /** @type {(inputs: Settings_Apikeys_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥已创建`)
};

/**
* | output |
* | --- |
* | "API key created" |
*
* @param {Settings_Apikeys_CreatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_created = /** @type {((inputs?: Settings_Apikeys_CreatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_CreatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_created(inputs)
	return zh_settings_apikeys_created(inputs)
});
export { settings_apikeys_created as "settings.apikeys.created" }